let url = new Object()
const name = `kontrollers`

const common = `/api/${name}/`
url.common = {
}

const adminUrl = `/api/${name}/admin/`
url.admin = {
  getOneFullMysql: `${adminUrl}getonefullmysql`,
  getAllStatusMysql: `${adminUrl}getallstatusmysql`,
  getFilters: `${adminUrl}getfilters`,
  updatePrograms: `${adminUrl}updateprograms`,
  getPrograms: `${adminUrl}getprograms`,
  startMassageAdmin: `${adminUrl}startmassage`,
  getLog: `${adminUrl}getlog`
}

const dealerUrl = `/api/${name}/dealer/`
url.dealer = {
  getOneFullMysql: `${dealerUrl}getonefullmysql`,
  getAllStatusMysql: `${dealerUrl}getallstatusmysql`,
  getFilters: `${dealerUrl}getfilters`,
  updatePrograms: `${dealerUrl}updateprograms`,
  getPrograms: `${dealerUrl}getprograms`,
  startMassageAdmin: `${dealerUrl}startmassage`,
  getLog: `${dealerUrl}getlog`
}

export default url
